import React from 'react';
import { translate as t } from 'admin-on-rest';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { uniqBy } from 'lodash';
import {
  List,
  ListItem,
  Divider,
  Card,
  CardTitle,
  FlatButton,
} from 'material-ui';

import EventIcon from 'material-ui/svg-icons/action/event';
import LocationIcon from 'material-ui/svg-icons/communication/location-on';
import PersonIcon from 'material-ui/svg-icons/social/person';
// import SchoolIcon from 'material-ui/svg-icons/social/school';
import ClockIcon from 'material-ui/svg-icons/device/access-time';
import { hasPositions, isSuperUser } from '../utils/permissionsUtils';

const styles = {
  removeRegistrationButton: {
    marginTop: '12px',
  },
};

const ProfileCourseList = ({ student, translate, ...props }) => {
  const { registrations,
    phoneNumber,
    // completedCourses,
  } = student;
  // const { fullName } = props.user;
  const uniqCourses = uniqBy(registrations, '_id');

  const courses = uniqCourses.length > 0 ? uniqCourses.map((course) => ({
    title: course.title,
    id: course._id,
    courseMoment: course.courseMoment.filter((courseMoment) => courseMoment.attendeesList.findIndex((attendees) => attendees.phoneNumber === phoneNumber) > -1) })) : [];

  return (
    <div>
      <Card>
        <CardTitle title={translate('academy.registeredCourses')} />
        {
          courses.length <= 0 ? (
            <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
              {translate('academy.noRegisteredCourses')}
              <Link to="/academy-viewer/courses">
                <FlatButton primary label={translate('academy.coursesLink')} />
              </Link>
            </div>
          ) : (
            <div>
              <Link to="/academy-viewer/courses">
                <FlatButton primary label={translate('academy.coursesLink')} />
              </Link>
              <RegistrationsList
                courses={courses}
                translate={translate}
                student={student}
                {...props}
              />
            </div>
          )
        }
      </Card>
      {
        // Object.keys(student).length > 0 && (
        //   <Card style={{ marginTop: '20px' }}>
        //     <CardTitle title={translate('academy.completedCourses')} />
        //     <List>
        //       {
        //         completedCourses.map((course) =>
        //           (<ListItem
        //             key={`${course.title}-completedCourses`}
        //             primaryText={course.title}
        //             containerElement={<Link to={{ pathname: `/profile/${phoneNumber}/diploma`, state: { title: course.title, name: fullName } }} />}
        //             leftIcon={<SchoolIcon />}
        //           />)
        //         )
        //       }
        //     </List>
        //   </Card>
        // )
        // <CompletedCourses completedCourses={student.completedCourses} translate={translate} user={student.phoneNumber} />
      }
    </div>
  );
};

const RegistrationsList = ({ courses, translate, removeRegistration, student, user, record }) => (
  courses.map((course) => (
    <List
      key={`${course.title}-listParent`}
    >
      <ListItem
        initiallyOpen
        key={`${course._id}-registrationList`}
        primaryText={course.title}
        primaryTogglesNestedList
        nestedItems={course.courseMoment.map((cMoment) => (
          <React.Fragment key={`${cMoment._id}-fragmentParent`}>
            <ListItem
              key={`${cMoment._id}-startDate`}
              leftIcon={<EventIcon />}
              primaryText={`${translate('date')}: ${moment(cMoment.start).format('YYYY DD/MM')} ${cMoment.end && `- ${moment(cMoment.end).format('YYYY DD/MM')}`} `}
            />
            <ListItem
              key={`${cMoment._id}-startTime`}
              leftIcon={<ClockIcon />}
              primaryText={`${translate('academy.startTime')}: ${moment(cMoment.startTime).format('HH:mm')}`}
            />
            <ListItem
              key={`${cMoment._id}-address`}
              leftIcon={<LocationIcon />}
              primaryText={`${translate('academy.address')}: ${cMoment.address}, ${cMoment.city}`}
            />
            <ListItem
              key={`${cMoment._id}-teacher`}
              leftIcon={<PersonIcon />}
              primaryText={`${translate('academy.teacher')}: ${cMoment.teacher}`}
            />
            <Divider inset key={`${cMoment._id}-divider`} />
            {
              (user &&
                (isSuperUser(user) || hasPositions(user, ['franchisees', 'restaurantManager']))
                && record.venues.some((venue) => user.venues.includes(venue))) && (
                <FlatButton
                  key={`${cMoment._id}-unRegister`}
                  style={styles.removeRegistrationButton}
                  primary
                  onClick={() => removeRegistration({ courseId: course.id, courseMomentId: cMoment._id, phoneNumber: student.phoneNumber })}
                  label={`${translate('academy.unRegister')} ${course.title}`}
                />
              )
            }
          </React.Fragment>
        ))}
      />
    </List>
  ))
);

// const CompletedCourses = ({ completedCourses = [], translate } = {}) => (

// );

export default t(ProfileCourseList);
